import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  clientOrders: {
    data: [],
    totalHits: 0,
    loading: false,
    error: false,
  },
  associateOrders: {
    data: [],
    totalHits: 0,
    loading: false,
    error: false,
  },
};

export const associateOrderHistory = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ASSOCIATE_ORDER_HISTORY_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case actionTypes.GET_ASSOCIATE_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.associateOrderItems,
        totalHits: payload.totalHits,
      };

    case actionTypes.GET_ASSOCIATE_ORDER_HISTORY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case actionTypes.RESET_ASSOCIATE_ORDER_HISTORY:
      return {
        ...INITIAL_STATE.associateOrders,
      };

    case actionTypes.RESET_ASSOCIATE_ORDER_HISTORY_KEEP_FILTERS:
      return {
        ...INITIAL_STATE.associateOrders,
      };
    case actionTypes.RESTORE_ASSOCIATE_ORDER_HISTORY:
      return {
        ...state,
        loading: false,
        data: payload,
      };

    default:
      return state;
  }
};

export const clientOrderHistory = (state, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_CLIENT_ORDER_HISTORY_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case actionTypes.GET_CLIENT_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.customerOrderItems,
        totalHits: payload.totalHits,
      };

    case actionTypes.GET_CLIENT_ORDER_HISTORY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case actionTypes.RESET_CLIENT_ORDER_HISTORY:
      return {
        ...INITIAL_STATE.clientOrders,
      };

    case actionTypes.RESET_CLIENT_ORDER_HISTORY_KEEP_FILTERS:
      return {
        ...INITIAL_STATE.clientOrders,
      };

    case actionTypes.RESTORE_CLIENT_ORDER_HISTORY:
      return {
        ...state,
        loading: false,
        data: payload,
      };

    default:
      return state;
  }
};

const orderHistory = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    clientOrders: { ...clientOrderHistory(state.clientOrders, action) },
    associateOrders: { ...associateOrderHistory(state.associateOrders, action) },
  };
};

export default orderHistory;
